export type { AnchorProps } from './types'

export { default } from './Anchor'
